import { Input, useToast } from '@chakra-ui/react'
import axios from 'axios'
import { ChangeEvent, FC, useRef, useState } from 'react'

import useFollowUpAlert from '@hook/alerts/use-followup'
import useUserRole from '@hook/shared/use-user-role'

import ImportarCSVModal, {
  ImportarCSVResultado
} from '@component/FollowUpFornecedor/ImportarCSVModal'

import followUpFornecedorService from '@service/followUpFornecedor'

import LayoutToolsButton from '../../Components/Button'

const ActionFollowUpRevisaoUpload: FC = () => {
  const { role } = useUserRole()
  const { getDatas } = useFollowUpAlert()
  const canEdit =
    role === 'Administrador' ||
    role === 'Comprador' ||
    role === 'AnalistaCompra'
  const [isLoading, setIsLoading] = useState(false)
  const [resultado, setResultado] = useState<ImportarCSVResultado | null>(null)
  const inputRef = useRef<HTMLInputElement>(null)
  const toast = useToast()

  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.value = ''
      inputRef.current.click()
    }
  }

  const handleChange = async (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return

    const ext = file.name.split('.').pop()?.toLowerCase()
    if (ext !== 'csv') {
      toast({
        title: 'Formato inválido',
        description: 'Apenas arquivos .csv são aceitos.',
        status: 'warning',
        duration: 4000,
        isClosable: true,
        position: 'top'
      })
      return
    }

    const MAX_SIZE = 5 * 1024 * 1024
    if (file.size > MAX_SIZE) {
      toast({
        title: 'Arquivo muito grande',
        description: 'O tamanho máximo permitido é 5MB.',
        status: 'warning',
        duration: 4000,
        isClosable: true,
        position: 'top'
      })
      return
    }

    setIsLoading(true)
    try {
      const { data: res } = await followUpFornecedorService.importarCSVRevisao(
        file
      )
      setResultado({
        success: res.success,
        message: res.message,
        data: res.data
      })
      if (res.success) getDatas()
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const res = err.response?.data as ImportarCSVResultado | undefined
        if (res?.message) {
          setResultado({
            success: false,
            message: res.message,
            data: res.data
          })
        } else {
          toast({
            title: 'Erro ao importar arquivo',
            status: 'error',
            duration: 4000,
            isClosable: true,
            position: 'top'
          })
        }
      } else {
        toast({
          title: 'Erro ao importar arquivo',
          status: 'error',
          duration: 4000,
          isClosable: true,
          position: 'top'
        })
      }
    } finally {
      setIsLoading(false)
    }
  }

  if (!canEdit) return null

  return (
    <>
      <LayoutToolsButton
        label="Upload de arquivo revisão"
        isLoading={isLoading}
        loadingText="Importando..."
        onClick={handleClick}
      />
      <Input
        ref={inputRef}
        display="none"
        type="file"
        accept=".csv"
        onChange={handleChange}
      />
      <ImportarCSVModal
        resultado={resultado}
        onClose={() => setResultado(null)}
      />
    </>
  )
}

export default ActionFollowUpRevisaoUpload
